/* eslint-disable no-multi-assign */
<template>
  <div
    id="anchor-container"
    class="anchor-container"
    :style="{'top': (defaultOffset + offsetTop) + 'px'}"
  >
    <ul class="anchor-list">
      <li
        v-for="(item,index) in anchorList"
        :key="index"
        class="anchor-list-item"
        :class="activeIndex === item.id ? 'anchor-list-active' : ''"
      >
        <a
          @click="onChangeAnchor(item.id)"
        >{{ item.name }}</a>
      </li>
    </ul>
  </div>
</template>
<script>

const defaultOffset = 56;

export default {
  name: 'Anchor',
  props: {
    anchorList: {
      default() {
        return [];
      },
      type: Array
    },
    offsetTop: {
      type: Number,
      default: 54
    }
  },
  data() {
    return {
      defaultOffset,
      scroll: 0,
      activeIndex: -1,
      isClick: false,
      anchorActive: 0,
      // isFixTop: false
    };
  },
  watch: {
    scroll() {
      this.loadSroll();
    },
    anchorActive: {
      handler(newv, oldv) {
        this.loadAnchorSroll(newv, oldv);
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.setScroll);
    this.$nextTick(() => {
      const index = window.location.hash.substr(1);
      if (index) {
        document.documentElement.scrollTop = document.getElementById(index).offsetTop + 110;
        this.activeIndex = index;
      }
      if (!index && this.anchorList.length > 0) {
        this.activeIndex = this.anchorList[0].id;
      }
      const anchor = document.getElementById('anchor-container');
      // eslint-disable-next-line max-len
      if (this.scroll > this.offsetTop || (window.location.hash && index !== this.anchorList[0].id)) {
        anchor.style.top = `${defaultOffset}px`;
        anchor.style.transition = '0.3s';
      }
    });
  },
  methods: {
    setScroll() {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
    },
    loadSroll() {
      this.loadAnchorSroll();
      this.setAnchorScroll();
      if (this.isClick) {
        return;
      }
      const dom = document.querySelectorAll('h2');
      for (let i = dom.length - 1; i >= 0 ; i--) {
        if (this.scroll > dom[i].offsetTop + 30 && dom[i].hasAttribute('id')) {
          this.activeIndex = dom[i].getAttribute('id');
          if (document.getElementsByClassName('anchor-list-active')[0]) {
            this.anchorActive = document.getElementsByClassName('anchor-list-active')[0].offsetTop;
          }
          break;
        }
      }
    },
    onChangeAnchor(id) {
      if (this.activeIndex === id) {
        return;
      }
      this.isClick = true;
      const dom = document.getElementById(id);
      document.documentElement.scrollTop = dom.offsetTop  + this.offsetTop;
      document.body.scrollTop = dom.offsetTop + this.offsetTop;
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      this.setAnchorScroll();
      this.$router.replace({ path: `${this.$route.path}#${id}` });
      this.activeIndex = id;
      this.timer = setTimeout(() => {
        this.isClick = false;
        clearTimeout(this.timer);
      }, 100);
    },
    setAnchorScroll() {
      const anchor = document.getElementById('anchor-container');
      if (this.scroll > this.offsetTop) {
        anchor.style.top = `${defaultOffset}px`;
        anchor.style.transition = '0.3s';
      } else {
        anchor.style.top = `${defaultOffset + (this.offsetTop - this.scroll)}px`;
      }
    },
    loadAnchorSroll() {
      const [anchorlist] = document.getElementsByClassName('anchor-list');
      anchorlist.scrollTop = this.anchorActive - (document.documentElement.clientHeight / 2);
    },
  },
};
</script>
<style lang="scss">
  .anchor-container {
    position: fixed;
    right: 0;
    top: 110px;
    height: calc(100% - 110px);
    margin-left: 6px;
    // overflow: hidden;
    width: 180px;
    .anchor-list {
      padding: 0;
      margin: 0;
      overflow: auto;
      max-height: 100%;
      &::-webkit-scrollbar {
        display: none;
      }
      &-item {
        padding-left: 1px;
        padding-right: 20px;
        list-style: none;
        margin-left: 1px;
        a {
          cursor: pointer;
          display: block;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #1B202C;
          line-height: 14px;
          padding: 8px 10px;
          border-left: 1px solid rgba($color: #535B6E, $alpha: 0.2);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      &-active {
        a {
          margin-left: -1px;
          border-left: 3px solid #0062FF;
          color:#0062FF;
        }
      }
    }
  }
  .fixed-top {
    transition: 0.3s;
    top: 56px;
  }
  @media screen and (max-width: 1329px) {
    .anchor-container {
      margin-top: -99999px;
    }
  }
</style>
